import { api } from '@/api';
import { UseActionExecuteType } from '@/models/action_base';
import { SurveyAnswerStateKbnConst } from '@/utils/survey_answer_state_kbn';

import { useRouting } from './use_routing';

async function isAnswered() {
  const response = await api.getIsAnswered();
  return response.surveyAnswerState === SurveyAnswerStateKbnConst.SURVEY_ANSWER_STATE_KBN_IS_ANSWERED;
}

/**
 * アンケート回答済みであれば、内部遷移する
 *
 *
 * オプション: 遷移先の URL
 */

export function useActionRedirectIfAnswered(router: ReturnType<typeof useRouting>, path?: string): UseActionExecuteType {
  return async () => {
    if (await isAnswered() && !!path) {
      await router.redirect(path);
      return true;
    }
    return false;
  };
}

/**
 * アンケート未回答であれば、内部遷移する
 *
 *
 * オプション: 遷移先の URL
 */

export function useActionRedirectIfNotAnswered(router: ReturnType<typeof useRouting>, path?: string): UseActionExecuteType {
  return async () => {
    if (!(await isAnswered()) && !!path) {
      await router.redirect(path);
      return true;
    }
    return false;
  };
}

